import { getHttpClient, errorDesconocido } from "../../../core/utils/httpClient";
import basicList from "../../../core/redux/actions/list";

import queryString from "query-string";

const PREFIX = "INVOICE_CLIENT_ASSIGN_JOB";
const getState = (state) => state.invoice.clientAssignJob;

const {
    /**
     * Main request & reset
     */
    getListPattern,
    listReset: reset,

    secondaryPutPattern,
    /**
     * Element's actions
     */
    actionDeletePattern,
    actionPutPattern,

    /**
     * Selectores
     */
    getMeta,
    getList,
    getError,
    isLoaded,
    isLoading,
    isSecondaryLoading,
    getSecondarySuccess,
} = basicList(PREFIX, getState);

const list = (queryParams) => {
    /**
     * Add hidden parameters to make the API call
     */
    const hiddenParams = { uncompensatedClient: 1 };

    /**
     * It's also possible to remove and sanitize some parameters
     */
    const customQueryParams = { ...queryParams, ...hiddenParams };

    /**
     * Call to the API
     */
    return getListPattern("react/jobs/v1/", customQueryParams);
};

export const listForClient = (queryParams, clientId) => {
    /**
     * Add hidden parameters to make the API call
     */
    const hiddenParams = { /* Borrar v1.31: uncompensatedClient: 1 ,*/ client: clientId };

    /**
     * It's also possible to remove and sanitize some parameters
     */
    const customQueryParams = { ...queryParams, ...hiddenParams };

    /**
     * Call to the API
     */
    return getListPattern("react/jobs/v1/", customQueryParams);
};

export { list, reset, getMeta, getList, getError, isLoaded, isLoading, isSecondaryLoading, getSecondarySuccess };

export const assignJob = (invoice, invoiceDetailPurchaseOrder, job) => {
    return secondaryPutPattern(
        "react/invoices/v1/" + invoice + "/client/assign/" + invoiceDetailPurchaseOrder + "/job/" + job,
        {},
        {
            message: "Invoice",
            description: "The Job was assigned.",
        }
    );
};

export const addJobToInvoice = (invoiceId, jobId) => {
    return secondaryPutPattern(
        "react/invoices/v1/" + invoiceId + "/client/add-job/" + jobId,
        {},
        {
            message: "Invoice",
            description: "The Job was added.",
        }
    );
};
